var React = require('react');

function IconClipboardInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.66695 3.40015H0.666992V13.0001H8.66695V3.40015Z","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2.2666 1H11.0666V11.3999","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3.06934 5.79993H6.26932","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M3.06934 8.20007H6.26932","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("path",{"d":"M3.06934 10.5999H6.26932","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":4})]);
}

IconClipboardInline.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = IconClipboardInline;

IconClipboardInline.default = IconClipboardInline;
